import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import firebase from 'firebase/app'
import 'firebase/auth'
import 'semantic-ui-css/components/site.css'

const FIREBASE_OPTIONS = require('../firebase-config-'+process.env.VUE_APP_MODE+'.json');

let app = '';

firebase.initializeApp(FIREBASE_OPTIONS);

Vue.config.productionTip = false;

//Plugins-------------------------------
require('./plugins');
//--------------------------------------

firebase.auth().onAuthStateChanged(() => {
    if (!app)
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
});
